const state = {
  sessionId: "",
};

const getters = {
  sessionId: (state) => {
    return state.sessionId;
  },
};

const mutations = {
  setId: (state, sessionId) => {
    state.sessionId = sessionId;
  },
};

const actions = {
  updateId: (context, sessionId) => {
    context.commit("setId", sessionId);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
